export const raffle = {
  raffleTitle: "Raffles",
  raffleBtnMyTickets: "My kaartjies",
  rafflePrize: "Prys",
  raffleBtnBuy: "Koop kaartjie",
  raffleStatus: "AKTIEF",
  raffleModalTitle: "Koop kaartjies vir ",
  raffleModalPrice: "Kaartjieprys",
  raffleModalTotalPrice: "TOTALE PRYS",
  raffleModalQuantity: "Voer 'n nommer in",
  raffleModalBtnBuy: "Koop kaartjie(s)",
  raffleModalBuyQuantity: "Hoeveel kaartjies wil jy koop?",
  raffleModalChooseNumber: "Kies 'n nommer",
  raffleModalChooseRandom: "Ewekansige nommer",
  raffleModalBackBtn: "Terug",
  raffleTicketPurchase: "Aankoop suksesvol!",
  raffleTicketCreatedMessage: "Voer asseblief 'n geldige nommer vir elke kaartjie in.",
  raffleTicketPurchaseError: "Fout met die koop van kaartjies. Probeer later weer.",
  raffleErrorMessage: "Fout met die koop van kaartjies.",
};
